import '@reduxjs/toolkit';
import 'react';
import { batch, useDispatch, useSelector, useStore } from 'react-redux';
import { capitalize } from '../utils/capitalize.js';
import { isQueryDefinition, isMutationDefinition } from '../endpointDefinitions.js';
import { safeAssign } from '../tsHelpers.js';
import { buildHooks } from './buildHooks.js';

const reactHooksModuleName = Symbol();
const reactHooksModule = ({
  batch: batch$1 = batch,
  useDispatch: useDispatch$1 = useDispatch,
  useSelector: useSelector$1 = useSelector,
  useStore: useStore$1 = useStore
} = {}) => ({
  name: reactHooksModuleName,

  init(api, options, context) {
    const {
      buildQueryHooks,
      buildMutationHook,
      usePrefetch
    } = buildHooks({
      api,
      moduleOptions: {
        batch: batch$1,
        useDispatch: useDispatch$1,
        useSelector: useSelector$1,
        useStore: useStore$1
      }
    });
    safeAssign(api, {
      usePrefetch
    });
    safeAssign(context, {
      batch: batch$1
    });
    return {
      injectEndpoint(endpoint, definition) {
        const anyApi = api;

        if (isQueryDefinition(definition)) {
          const {
            useQuery,
            useQueryState,
            useQuerySubscription
          } = buildQueryHooks(endpoint);
          safeAssign(anyApi.endpoints[endpoint], {
            useQuery,
            useQueryState,
            useQuerySubscription
          });
          api[`use${capitalize(endpoint)}Query`] = useQuery;
        } else if (isMutationDefinition(definition)) {
          const useMutation = buildMutationHook(endpoint);
          safeAssign(anyApi.endpoints[endpoint], {
            useMutation
          });
          api[`use${capitalize(endpoint)}Mutation`] = useMutation;
        }
      }

    };
  }

});

export { reactHooksModule, reactHooksModuleName };
//# sourceMappingURL=module.js.map
